"use client"

import { usePathname } from "next/navigation"
import { ReactNode } from "react"

interface BackgroundProviderProps {
  children: ReactNode
}

export function BackgroundProvider({ children }: BackgroundProviderProps) {
  const pathname = usePathname()
  const isHomePage = pathname === "/"

  return (
    <div className={`min-h-screen ${isHomePage ? "bg-[#0B1033]" : "bg-white"}`}>
      {children}
    </div>
  )
}
